import React from "react";
function NoPage() {
  return <h1>no page</h1>;
}
export default NoPage;
